import { createContext } from 'react';

/**
 * How links in text (MentionText) open, SF-T-160: `page` as links do (the default), `dialog` in the
 * link dialogs (the chat and task comments), `inDialog` inside the link dialog itself, where a
 * factory link moves the dialog on to its page.
 */
export type LinkScope = 'page' | 'dialog' | 'inDialog';

export const LinkScopeContext = createContext<LinkScope>('page');
